import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Spinner } from 'reactstrap';
import { FaCheckCircle } from 'react-icons/fa';
import Select from 'react-select';
import { APPROVAL_ACTION_CONFIGURATION, APPROVAL_ACTION_CONFIGURATION_EMPTY, GET_REASON_BY_ACTIONS } from '../../../../../../../../store/actions';
import { Error } from '../../../../../../../Common';
import { useDispatch, useSelector } from 'react-redux';
import check from '../../../../../../../../assets/custom/v2/check.svg';

const ApprovalActionForPricing = ({ onClose, currentSelectedBooking, actionType, approvalType, cardName, currentActiveBookingAction }) => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [isShowError, setIsShowError] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { approvalAction, approvalActionLoading, remarksList, remarksListLoading } = useSelector(state => ({
    approvalAction: state?.ApprovalActionConfiguration?.data,
    approvalActionLoading: state?.ApprovalActionConfiguration?.loading,

    remarksList: state?.GetReasonByActions?.data,
    remarksListLoading: state?.GetReasonByActions?.loading,
  }));

  /* ---------------------------- INPUT SELECT HANDLER ---------------------------- */
  const inputSelectHandler = (label, data) => {
    if (label === `reason_id`) {
      setSelectedRemark(data);
    } else {
      setIsShowError(false);
    }
  };

  const handleSubmit = () => {
    if (selectedRemark) {
      if (actionType === 'approve') {
        dispatch({
          type: APPROVAL_ACTION_CONFIGURATION,
          payload: {
            body: {
              action: 'approve',
              id: currentSelectedBooking?.id,
              cardName: cardName,
              reasonId: selectedRemark?.value,
            },
          },
        });
      } else {
        dispatch({
          type: APPROVAL_ACTION_CONFIGURATION,
          payload: {
            body: {
              action: 'reject', // approve/reject,
              id: currentSelectedBooking?.id,
              cardName: cardName,
              reasonId: selectedRemark?.value,
            },
          },
        });
      }
    } else setIsShowError(true);
  };

  useEffect(() => {
    if (approvalAction !== null) {
      dispatch({
        type: APPROVAL_ACTION_CONFIGURATION_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: APPROVAL_ACTION_CONFIGURATION_EMPTY,
      });
    };
  }, [approvalAction]);

  useEffect(() => {
    dispatch({
      type: GET_REASON_BY_ACTIONS,
      payload: {
        urlParams: {
          booking_type: currentSelectedBooking?.bookingType || '',
          booking_status: currentSelectedBooking?.bookingStatus,
          action: currentActiveBookingAction,
          is_active: true,
          page_size: 50,
          page_index: 0,
        },
      },
    });
  }, [currentSelectedBooking]);

  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose} style={{ alignItems: 'flex-start' }}>
        <p className="approval-action-heading">{actionType === 'reject' ? 'Reject Changes' : 'Accept Changes'}</p>
      </ModalHeader>

      <ModalBody className="mt-3">
        <div className="position-relative">
          {currentSelectedBooking?.approvalTimeline?.map((entry, index) => (
            <div className="approval-action-timeline-item" key={index}>
              <div className="approval-action-timeline-icon">
                <img src={check} alt="" />
              </div>

              <div className="approval-action-timeline-content">
                <div>
                  <span className="approval-action-sub-title fw-light">{entry?.title}</span>
                  <strong className="fw-medium"> {entry?.username}</strong>
                </div>

                <div className="approval-action-timeline-date mt-1 fs-12">Initiated on {entry?.timestamp}</div>

                <div className="approval-action-timeline-message">{entry?.message}</div>
              </div>

              {index !== currentSelectedBooking?.approvalTimeline?.length - 1 && <div className="approval-action-timeline-line" />}
            </div>
          ))}
        </div>

        <div className="mb-3">
          <Label htmlFor="name" className="form-label">
            Remarks
          </Label>
          <Select
            id="decline-remarks"
            name="decline-remarks"
            placeholder={`Select reason for ${actionType} the ${approvalType}`}
            value={selectedRemark}
            options={remarksList?.reasons?.map((remark, index) => ({
              label: `${remark?.reason}`,
              value: `${remark?.id}`,
            }))}
            onChange={data => inputSelectHandler(`reason_id`, data)}
          />
          {isShowError && selectedRemark === null && <Error text={`Kindly select reason for ${actionType} the ${approvalType}`} ref={null} />}
        </div>
      </ModalBody>

      <ModalFooter style={{ margin: 'auto' }}>
        {approvalActionLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }}>
            <Spinner className="btn-replacer-spinner" />
          </Button>
        )}
        {!approvalActionLoading && (
          <Button color="primary" onClick={handleSubmit}>
            {actionType === 'approve' ? 'Accept' : 'Reject'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ApprovalActionForPricing;
